import type { EnemyKind } from "./types";

/** 敌人的辨识、反制与时间窗口集中定义，图鉴和实际战斗共用数据。 */
export const ENEMIES: Record<
  EnemyKind,
  {
    name: string;
    role: string;
    counter: string;
    windup: number;
    recovery: number;
    range: number;
    color: string;
  }
> = {
  sentinel: {
    name: "琥甲盾卫",
    role: "盾阵 · 正面减伤与长枪突刺",
    counter: "绕背攻击；灵潮或焰椒打断后盾失效，破绽期全额伤害。",
    windup: 1.15,
    recovery: 1.7,
    range: 145,
    color: "#eac279",
  },
  moth: {
    name: "织雾蛾",
    role: "支援 · 蓄力治疗周围敌人",
    counter: "优先集火；灵潮打断治疗。没有伤员时发射孢子。",
    windup: 1.5,
    recovery: 1.3,
    range: 300,
    color: "#bfd0ff",
  },
  mite: {
    name: "荆棘猎螨",
    role: "追猎 · 锁定直线后扑击",
    counter: "横向离开红色轨迹；扑空后反击。",
    windup: 0.85,
    recovery: 0.9,
    range: 165,
    color: "#f5a36a",
  },
  brute: {
    name: "裂岩重卫",
    role: "破阵 · 蓄力范围震地",
    counter: "离开圆形预警；砸地后虚弱，伤害提升 40%。",
    windup: 1.3,
    recovery: 1.6,
    range: 110,
    color: "#ed796d",
  },
  spitter: {
    name: "幽伞孢母",
    role: "远程 · 后撤与三向孢子弹",
    counter: "从弹幕间隙接近，用灵潮打断蓄力。",
    windup: 1.05,
    recovery: 1.1,
    range: 325,
    color: "#d291f2",
  },
};

export function segmentDistance(
  p: { x: number; y: number },
  a: { x: number; y: number },
  b: { x: number; y: number },
): number {
  const dx = b.x - a.x,
    dy = b.y - a.y,
    length = dx * dx + dy * dy;
  const t = length
    ? Math.max(0, Math.min(1, ((p.x - a.x) * dx + (p.y - a.y) * dy) / length))
    : 0;
  return Math.hypot(p.x - a.x - t * dx, p.y - a.y - t * dy);
}
